import { render, staticRenderFns } from "./ModalChatTranscript.vue?vue&type=template&id=2f70fc4e"
import script from "./ModalChatTranscript.vue?vue&type=script&lang=js"
export * from "./ModalChatTranscript.vue?vue&type=script&lang=js"
import style0 from "./ModalChatTranscript.vue?vue&type=style&index=0&id=2f70fc4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports